{
  "divisions": {
    "divisions": [],
    "includeSubDivisions": false
  },
  "company": [],
  "location": [],
  "country": [],
  "jobTitle": [],
  "personTags": [],
  "personTagTypes": [],
  "teams": {
    "includeSubTeams": true,
    "teams": [],
    "types": []
  }
}